import EventBus from './../event-bus';
import {
    NOTIFICATION_TITLES,
    NOTIFICATION_MESSAGES,
    NOTIFICATION_DURATION
} from './../constants/notification-constants';
import { SHOW_NOTIFICATION } from '../constants/event-constants';

// Show notification
function showNotification(notification) {
    console.log('showNotification: ', notification);
    EventBus.$emit(SHOW_NOTIFICATION, notification);
}

// Parse errors function
function parseErrorMessage(message, messageTitle) {
    let text = NOTIFICATION_MESSAGES.error;
    let title = messageTitle;
    if (Array.isArray(message)) {
        text = message.join(',');
    } else if (typeof message === 'string') {
        text = message;
    }
    return { text, title };
}

function notifyError(message, title = NOTIFICATION_TITLES.error, duration = NOTIFICATION_DURATION.error) {
    const errorMessage = parseErrorMessage(message, title);
    const notification = {
        type: 'error',
        text: errorMessage.text,
        title: errorMessage.title,
        duration
    };
    showNotification(notification);
}

function notifySuccess(message, title = NOTIFICATION_TITLES.success, duration = NOTIFICATION_DURATION.success) {
    const notification = {
        type: 'success',
        text: message,
        title,
        duration
    };
    showNotification(notification);
}

function notifyWarning(message, title = NOTIFICATION_TITLES.warning, duration = NOTIFICATION_DURATION.warning) {
    const notification = {
        type: 'warn',
        text: message,
        title,
        duration
    };
    showNotification(notification);
}

export {
    notifyError,
    notifySuccess,
    notifyWarning
}
